import { GridCellProps, GridCustomCellProps } from '@progress/kendo-react-grid';
import { GridCellTd } from '../../../../../../../common/widgets/Grid';
import { useTranslation } from 'react-i18next';
import { resources } from '../../../../../resources/resources';
import { AttendenceTypeModel } from '../../../../../models/AttendenceType';
import Icons from '../../../../../../../common/widgets/Icons';

export const TypeDescriptionCell = ({ dataItem }: GridCellProps) => (
  <GridCellTd>{dataItem.typeDescription}</GridCellTd>
);

export const HoursCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  const { t: translate } = useTranslation();

  return (
    <GridCellTd {...props}>
      {dataItem.hours}{' '}
      {translate(resources.admin.timesheetsSettings.types.hours)}
    </GridCellTd>
  );
};

export const ShortNotationCell = ({ dataItem }: GridCellProps) => (
  <GridCellTd>{dataItem.shortNotation}</GridCellTd>
);
/* display: 'inline-block',
  padding-block: 0.4rem;
  padding-inline: 1rem;
  background-color: #daedb4;
  color: $color-base;
  font-size: 1.2rem;
  line-height: 1.4rem;
  font-weight: 500;
  white-space: nowrap;
  border-radius: 15px; */
export const ColorCell = (props: GridCustomCellProps) => {
  const { dataItem } = props;
  return (
    <GridCellTd>
      <span
        className="timesheet-type-card"
        style={{
          backgroundColor: `#${dataItem.bgColor}`,
          color: `#${dataItem.fgColor}`,
        }}
      >
        {dataItem.bgColor}
      </span>
    </GridCellTd>
  );
};

export interface ResendEmailCellProps extends GridCustomCellProps {
  handleEditAtendenceType: (dataItem: AttendenceTypeModel) => void;
}

export const EditActionCell = (props: ResendEmailCellProps) => {
  const { dataItem, handleEditAtendenceType } = props;
  const { t: translate } = useTranslation();
  return (
    <GridCellTd className="grid-actions-cell">
      <button
        className="btn-link grid-action-nav"
        onClick={() => handleEditAtendenceType(dataItem)}
      >
        <span className="btn-icon">
          <Icons.ArrowButton />
        </span>
        <span className="btn-text">
          {translate(resources.admin.timesheetsSettings.types.gridAction)}
        </span>
      </button>
    </GridCellTd>
  );
};
